import React,{useState} from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col } from 'react-bootstrap';
import './form.css';
import James from '../assets/t2.jpeg';
import Bob from '../assets/t1.jpeg';
import { useSnackbar } from "notistack"
import axios from 'axios'

const url = "https://www.bitmasta.io/php/functioned.php"
export default function Form() {
    const [inputs,setInputs] = useState({
        name:"",
        email:"",
        phone:"",
        message:""
    })
    const { enqueueSnackbar } = useSnackbar();
    const handleAgent = () =>{
        enqueueSnackbar("Coming Soon", {
            variant: "info",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            }
          })   
    }
    const handleSubmit = async (e)=>{
        const {name,email,phone,message} = inputs
        e.preventDefault()
        if(!name || !email || !phone ||!message){
            enqueueSnackbar("All fields are required", {
                variant: "error",
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "right",
                }
              })
        }
        else{
            const formData = new FormData()
            formData.append("Contact_Name", name);
            formData.append("Contact_Email", email);
            formData.append("Contact_Phone", phone);
            formData.append("Contact_Message", message);
            const res = await axios.post(url, formData)
            if (res.data.status === "Mail Sent Success")
            enqueueSnackbar(res.data.message, {
                variant: "success",
                anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
                },
            });
            else if(res.data.status === "Message could not be sent")
            enqueueSnackbar("An error occur! Please try again", {
                variant: "error",
                anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
                },
            });
        }
    }
    return (
        <Container fluid>
            <Container className="bts-form-wrapper">
                <Row >
                    <Col md={{ span: 4, offset: 1 }} className="col-sm-12 px-0">
                        <p className="b7 med blueText smpush">Testimonies or Feedback?</p>
                        <form action="post">
                            <div>
                                <input type="text" value={inputs.name} onChange={(e)=>setInputs({...inputs,name:e.target.value})} placeholder="Your Name" id="" className="bts-input w-100 form-input"/>
                            </div>
                            <div>
                                <input type="email" value={inputs.email} onChange={(e)=>setInputs({...inputs,name:e.target.value})} placeholder="Your Email" id="" className="bts-input w-100 form-input"/>
                            </div>
                            <div>
                                <input type="number" value={inputs.phone} onChange={(e)=>setInputs({...inputs,phone:e.target.value})} placeholder="Phone Number" id="" className="bts-input w-100 form-input"/>
                            </div>
                            <div>
                                <textarea placeholder="Message" className="w-100" value={inputs.message} onChange={(e)=>setInputs({...inputs,message:e.target.value})}></textarea>
                            </div>
                            <button type="submit" onClick={handleSubmit} className="bts-submit w-100">Submit</button>
                        </form>
                    </Col>
                    <Col md={{ span: 4, offset: 1 }} className="col-sm-12 px-0">
                        <>
                            <Fade bottom delay={1200}>
                                <div className="d-flex sidePadding ppptttt">
                                <div>
                                    <img src={James} alt="" className="bts-testimonials-image rounded-circle"/>
                                </div>
                                <div className="align-self-center pl-4 lightText">
                                The platform looks great, I am particularly impressed with the fact that you can go through the site even without registering.      
                                <h4 className="pt-2 lightBlue medText b7">Chibike</h4>   
                                </div>
                                </div>
                            </Fade>
                            
                            <Fade bottom delay={1300}>
                                <div className="d-flex float-right sidePadding push">
                                <span>
                                    <img src={Bob} alt="bitmasta testimonials" className="bts-testimonials-image rounded-circle"/>
                                </span>
                                <span className="align-self-center pl-4 lightText">
                                    I’ve tried several bitcoin exchange platforms 
                                    and been burned. But Bitmasta is the real deal. 
                                    Definitely worth the wait!
                                    <h4 className="pt-2 lightBlue medText b7">Olumide</h4>   
                                </span>
                                </div>
                            </Fade>
                        </>
                    </Col>
                </Row>
            </Container>
            <Row className="bts-agent">
                <Container>
                    <Col md={12} className="px-0 whiteText">
                        <Row>
                            <Col md={6} >
                                <h1>Become a Bitmasta Agent <br className="disappear" />and earn passively</h1>
                            </Col>
                            <Col md={5} className="">
                                <Fade bottom delay={500}>
                                    <span onClick={handleAgent} className="whiteText cursor bts-fom float-right">Find out how</span>                          
                                </Fade>
                            </Col>
                        </Row>
                    </Col>
                </Container>
            </Row>
        </Container>
    )
}
